<template>
  <v-sheet class="rounded border" color="white">
    <SoProgress v-if="isLoading" type="linear" indeterminate height="1" />
    <div class="d-flex gap-1">
      <div class="pl-2 pt-2">
        <v-icon :icon="attachment.icon" size="small"></v-icon>
      </div>
      <SoLink class="pa-2" @click="handleAttachmentClick">
        <div class="text-end attachments__container">
          <div class="attachments__name text-body-2 font-weight-medium">
            {{ attachment.name }}
          </div>
        </div>
      </SoLink>
    </div>
  </v-sheet>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IFreshdeskAttachment } from "@/models/freshdeskThreadConversation/freshdeskThreadConversation.types"
  import { FreshdeskService } from "@/services/FreshdeskService"
  import { downloadFromSignedUrl } from "@/helpers/downloadFile"
  import SoLink from "@/components/SoLink.vue"
  import SoProgress from "@/components/SoProgress.vue"
  import { errorHandler } from "@/services/ErrorService"

  export default defineComponent({
    components: { SoLink, SoProgress },
    inheritAttrs: false,
    props: {
      attachment: {
        type: Object as PropType<IFreshdeskAttachment>,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
      }
    },
    methods: {
      async handleAttachmentClick() {
        try {
          this.isLoading = true

          const { data: url } = await FreshdeskService.getLegacyAttachment(
            this.attachment.path,
          ).refetch()

          await downloadFromSignedUrl(
            String(url),
            this.attachment.name,
            this.attachment.type,
          )
        } catch (error) {
          errorHandler.handleGenericError(error as Error)
        } finally {
          this.isLoading = false
        }
      },
    },
  })
</script>

<style scoped>
  .attachments__container {
    max-width: 120px;
  }
  .attachments__name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
